var map = {
	"./401.svg": 684,
	"./401_old.svg": 976,
	"./audio.svg": 671,
	"./browsers.svg": 574,
	"./dashboard.svg": 702,
	"./denied.svg": 687,
	"./devices_re.svg": 680,
	"./doc.svg": 703,
	"./empty.svg": 292,
	"./fb.svg": 977,
	"./icono-task.svg": 978,
	"./ig.svg": 979,
	"./info.svg": 688,
	"./kanban.svg": 689,
	"./payment/paypal.svg": 704,
	"./people_search.svg": 980,
	"./safe.svg": 665,
	"./send-mail.svg": 981,
	"./tasks.svg": 456,
	"./tg-1.svg": 982,
	"./tg.svg": 983,
	"./undraw_bus_stop_re_h8ej.svg": 984,
	"./undraw_personal_text_re_vqj3.svg": 557,
	"./undraw_sync_re_492g.svg": 690,
	"./undraw_web_devices_re_m8sc.svg": 985,
	"./video.svg": 672,
	"./ws-1.svg": 986,
	"./ws.svg": 666
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 670;